"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _ServiceLocator = _interopRequireDefault(require("chaire-lib-common/lib/utils/ServiceLocator"));
var _LodashExtensions = require("chaire-lib-common/lib/utils/LodashExtensions");
var _OctaviParameters = _interopRequireDefault(require("../../../services/ui/OctaviParameters"));
var _utils = require("../../../services/ui/utils");
class FilterExtract extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      comparisonIsSelected: _OctaviParameters.default.get('comparisonIsSelected', false),
      filters: _OctaviParameters.default.filters
    };
    this.updateComparisonSelection = this.updateComparisonSelection.bind(this);
    this.updateFilters = this.updateFilters.bind(this);
    this.onDownloadClick = this.onDownloadClick.bind(this);
  }
  componentDidMount() {
    _ServiceLocator.default.eventManager.on('taxi.filter.comparisonIsSelected.update', this.updateComparisonSelection);
    _ServiceLocator.default.eventManager.on('taxi.filter.submit', this.updateFilters);
  }
  componentWillUnmount() {
    _ServiceLocator.default.eventManager.off('taxi.filter.comparisonIsSelected.update', this.updateComparisonSelection);
    _ServiceLocator.default.eventManager.off('taxi.filter.submit', this.updateFilters);
  }
  updateComparisonSelection() {
    this.setState({
      comparisonIsSelected: _OctaviParameters.default.comparisonIsSelected
    });
  }
  updateFilters() {
    const newFilters = _OctaviParameters.default.filters;
    this.setState({
      filters: newFilters
    });
  }
  onDownloadClick() {
    (0, _utils.exportFilter)(this.state.filters, this.state.comparisonIsSelected ? [0, 1] : [0], this.props.t);
  }
  render() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "filter-overlay-download"
    }, /*#__PURE__*/_react.default.createElement("button", {
      className: "button grey",
      type: "button",
      onClick: () => this.onDownloadClick()
    }, /*#__PURE__*/_react.default.createElement("img", {
      className: `_icon chart_line_white`,
      src: "/dist/images/icons/octavi/export_to_file_white.svg",
      alt: "settings"
    })));
  }
}
var _default = exports.default = (0, _reactI18next.withTranslation)()(FilterExtract);